import type { Locale } from '@estimating/i18n';
import type { Locale as AntdLocale } from 'antd/es/locale';
import enUS from 'antd/locale/en_US';
import esUS from 'antd/locale/es_US';
import frCA from 'antd/locale/fr_CA';
import 'dayjs/locale/en-ca';
import 'dayjs/locale/es-us';
import 'dayjs/locale/fr-ca';

/** Ant Design has no en_CA pack; en_US differs only in date formats we don't use yet. */
export const antdLocales: Readonly<Record<Locale, AntdLocale>> = {
  'en-CA': enUS,
  'fr-CA': frCA,
  'en-US': enUS,
  'es-US': esUS,
};

export const dayjsLocales: Readonly<Record<Locale, string>> = {
  'en-CA': 'en-ca',
  'fr-CA': 'fr-ca',
  'en-US': 'en',
  'es-US': 'es-us',
};
